<template>
	<div id="modal-common-adjust-columns">
		<b-modal :id="modalName" hide-footer size="sm">
            <template v-slot:modal-title>
                Adjust Columns
            </template>

            <b-table-simple hover small caption-top bordered responsive class="adjust-columns-table">
                <b-tbody v-if="pinnedCheckboxField">
                    <b-tr class="adjust-columns-pinned">
                        <b-td class="text-muted">
                            <i class="fas fa-lock fa-xs" title="Fixed column"></i>
                        </b-td>
                        <b-td class="text-muted">
                            <span>Selection</span>
                        </b-td>
                    </b-tr>
                </b-tbody>
                <b-tbody ref="adjustableList">
                    <b-tr
                        v-for="(field, index) in adjustableFields"
                        :key="field.key"
                        :class="{ 'adjust-columns-dragging': dragFromIndex === index }"
                        draggable="true"
                        @dragstart="onDragStart(index, $event)"
                        @dragover.prevent="onDragOver(index, $event)"
                        @drop.prevent="onDrop(index)"
                        @dragend="onDragEnd"
                    >
                        <b-td>
                            <b-form-checkbox
                                :id="'checkbox-adjust-' + field.key"
                                :value="parseInt(1)"
                                v-model="field.visible"
                                :unchecked-value="parseInt(0)"
                            >
                            </b-form-checkbox>
                        </b-td>
                        <b-td>
                            <i class="fas fa-grip-vertical adjust-columns-drag-handle text-muted" title="Drag to reorder"></i>
                            <span v-if="field.key == 'thumb'" class="ml-1">Thumbnail</span>
                            <span v-else class="ml-1">{{ field.label }}</span>
                        </b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>

            <b-button type="submit" variant="success" @click="adjustColumns">
                <span v-if="submitting">
                    <b-spinner small type="grow"></b-spinner>
                    Adjusting...
                </span>
                <span v-else>Update</span>
            </b-button>
        </b-modal>
	</div>
</template>

<script>
    const arrayMove = require('array-move')
    import { isPinnedColumnKey, normalizeColumnOrder } from '../../../../mixins/tableColumnPreferences'

	export default {
		props: [
            'fields'
		],

		data() {
			return {
				modalName: 'modal-common-adjust-columns',
                submitting: 0,
                adjustableFields: [],
                dragFromIndex: null
			}
		},

		watch: {
            fields: {
                immediate: true,
                handler() {
                    this.initAdjustableFields()
                }
            }
		},

		methods: {
            initAdjustableFields() {
                if (!this.fields || !this.fields.length) {
                    this.adjustableFields = []
                    return
                }

                this.adjustableFields = this.fields
                    .filter(field => !isPinnedColumnKey(field.key))
                    .map(field => ({ ...field }))
            },

            onDragStart(index, event) {
                this.dragFromIndex = index
                if (event.dataTransfer) {
                    event.dataTransfer.effectAllowed = 'move'
                    event.dataTransfer.setData('text/plain', String(index))
                }
            },

            onDragOver(index, event) {
                if (event.dataTransfer) {
                    event.dataTransfer.dropEffect = 'move'
                }
            },

            onDrop(toIndex) {
                if (this.dragFromIndex === null || this.dragFromIndex === toIndex) {
                    return
                }

                this.adjustableFields = arrayMove(this.adjustableFields, this.dragFromIndex, toIndex)
                this.dragFromIndex = null
            },

            onDragEnd() {
                this.dragFromIndex = null
            },

            buildMergedFields() {
                const checkbox = this.fields.find(f => f.key === 'checkbox')
                const actions = this.fields.find(f => f.key === 'actions')
                const merged = []

                if (checkbox) {
                    merged.push({ ...checkbox, visible: parseInt(checkbox.visible) })
                }

                this.adjustableFields.forEach(field => {
                    merged.push({
                        ...field,
                        visible: parseInt(field.visible)
                    })
                })

                if (actions) {
                    merged.push({ ...actions, visible: parseInt(actions.visible) })
                }

                return normalizeColumnOrder(merged)
            },

            adjustColumns() {
                const mergedFields = this.buildMergedFields()

                this.closeModal(this.modalName)
                this.showAlertBox('success', 'Columns Adjusted', 'Columns adjusted successfully!')
                this.$emit('saveColSaves', mergedFields)
            }
		},

		computed: {
            pinnedCheckboxField() {
                return this.fields && this.fields.find(f => f.key === 'checkbox')
            }
		}
	}
</script>
<style lang="scss">
    #modal-common-adjust-columns {
        .modal-dialog {
            width: 280px;
        }

        .adjust-columns-drag-handle {
            cursor: grab;
        }

        .adjust-columns-drag-handle:active {
            cursor: grabbing;
        }

        .adjust-columns-pinned td {
            border-bottom: 1px solid #dee2e6;
        }

        tr.adjust-columns-dragging {
            opacity: 0.5;
            background: #f8f9fa;
        }
    }
</style>
